var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"benefits"},[_c('div',{staticClass:"benefits-title"},[_vm._v(_vm._s(_vm.section.treatment.more.benefit.title))]),_c('div',{staticClass:"benefits-text",domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }